import { Description as HeadlessDescription } from "@headlessui/react";
import { classNames } from "../../utils/classNames";
import { Text } from "../Text";

export function AlertDescription({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div">) {
  return (
    <HeadlessDescription
      as={Text}
      {...props}
      className={classNames(
        className,
        "mt-2 text-pretty text-center sm:text-left",
      )}
    />
  );
}
